import { render } from "./StudentObservation.vue?vue&type=template&id=6cabca41"
import script from "./StudentObservation.vue?vue&type=script&lang=js"
export * from "./StudentObservation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__